import type { UiKey } from "../i18n/ui";

type Props = { t: (key: UiKey) => string };

const KEYS: UiKey[] = [
  "enterprise.b1",
  "enterprise.b2",
  "enterprise.b3",
  "enterprise.b4",
  "enterprise.b5",
];

export function EnterpriseRoadmap({ t }: Props) {
  return (
    <div className="ent-roadmap">
      <h2>{t("enterprise.title")}</h2>
      <p className="lead">{t("enterprise.lead")}</p>
      <ul>
        {KEYS.map((k) => (
          <li key={k}>{t(k)}</li>
        ))}
      </ul>
      <style>{`
        .ent-roadmap {
          padding: 0.85rem 1rem;
          border-radius: 10px;
          border: 1px dashed var(--border);
          background: var(--surface);
          opacity: 0.95;
        }
        .ent-roadmap h2 {
          font-size: 0.95rem;
          margin: 0 0 0.4rem;
          color: var(--muted);
        }
        .lead {
          margin: 0 0 0.5rem;
          font-size: 0.8rem;
          color: var(--muted);
          line-height: 1.45;
        }
        .ent-roadmap ul {
          margin: 0;
          padding-left: 1.1rem;
          font-size: 0.78rem;
          color: var(--muted);
          line-height: 1.5;
        }
      `}</style>
    </div>
  );
}
